module.exports = __webpack_public_path__ + "img/四川天府新区南湖小学（北区）.5680e489.jpg";